export const FILTER_NAME = 'stock_aging'
